export const getDevice = () => {
  const device = /Mobi|Android|iPhone|iPad|Opera Mini/i.test(
    navigator.userAgent
  )
    ? 'mobile'
    : 'desktop'
  return device
}
